import { isArray, isDefined, isDev } from "../utils/index.js";
function getComponentElements(nameOrSelector, element = document) {
  const selector = `[data-component="${nameOrSelector}"]`;
  let elements = [];
  try {
    elements = Array.from(element.querySelectorAll(selector));
  } catch {
  }
  if (elements.length === 0) {
    elements = Array.from(element.querySelectorAll(nameOrSelector));
  }
  return elements;
}
function eventIsDefinedInConfig(event, config) {
  return isArray(config.emits) && config.emits.includes(event);
}
function eventIsNative(event, element) {
  return isDefined(element[`on${event}`]);
}
function getEventTarget(instance, event, config) {
  if (eventIsDefinedInConfig(event, config)) {
    return instance;
  }
  if (eventIsNative(event, instance.$el)) {
    return instance.$el;
  }
  if (isDev) {
    console.warn(
      `[${config.name}]`,
      `The "${event}" event is missing from the configuration and is not a native`,
      `event for the root element of type \`${instance.$el.constructor.name}\`.`
    );
  }
  return instance;
}
export {
  eventIsDefinedInConfig,
  eventIsNative,
  getComponentElements,
  getEventTarget
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
